if (typeof tck !== 'undefined') {
	// Start browser fingerprint tracking
	// with delay of 2 seconds
	setTimeout(function() {
		Fingerprint2.getV18({}, function(result, components) {
			axios.post(trackingEndpoint, {
				type: 'browserFingerprint',
				token: tck,
				value: result
			}).then(function (response) {
				console.log("watado-Affiliate-System: Browser-Fingerprint-Tracking gestartet.");
			}).catch(function (error) {
				console.log(error);
			});
		});
	}, 2000);
}

if (typeof completeBooking !== 'undefined') {
	// Complete browser fingerprint tracking
	Fingerprint2.getV18({}, function(result, components) {
		axios.post(completeTrackingEndpoint, {
			type: 'browserFingerprint',
			booking: completeBooking,
			value: result
		}).then(function (response) {
			console.log("watado-Affiliate-System: Browser-Fingerprint-Tracking abgeschlossen.");
		}).catch(function (error) {
			console.log(error);
		});
	});
}
